import domContentLoaded from "dom-content-loaded";
import $ from "jquery";

domContentLoaded(() => {
  // 郵便番号の「-」の挿入
  $(".js-insert-hyphen").blur((e) => {
    // eslint-disable-next-line max-len
    const insertStr = (str, index, insert) =>
      str.slice(0, index) + insert + str.slice(index, str.length);
    const input = e.currentTarget;
    const zip = input.value;
    if (zip.length > 6 && !zip.match("-")) {
      input.value = insertStr(zip, 3, "-");
    }
  });

  // 入力項目の切り替え
  // const $switchTrigger = $('.js_formSwitch_trigger');
  // const $switchItems = $('.js_formSwitch_item');
  // const formSwitcher = (triggerVal) => {
  // 	$switchItems.each((index, element) => {
  // 		const $switchItem = $(element);
  // 		const switchItemTriggers = $(element).data('form-trigger').split(',');
  // 		if (switchItemTriggers.includes(triggerVal)) {
  // 			$switchItem.find('select, option, input, textarea').prop('disabled', false);
  // 			$switchItem.slideDown(100);
  // 		} else {
  // 			$switchItem.find('select, option, input, textarea').prop('disabled', true);
  // 			$switchItem.slideUp(100);
  // 		}
  // 	});
  // };
  // // 初期処理
  // const $switchTriggerDefault = $switchTrigger.find('select').val() || $switchTrigger.find('input[type="radio"]:checked').val();
  // if ($switchTriggerDefault) {
  // 	formSwitcher($switchTriggerDefault);
  // } else {
  // 	$switchItems.find('select, option, input, textarea').prop('disabled', true);
  // }

  // // トリガーが変化した時
  // $switchTrigger.on('change', (e) => {
  // 	formSwitcher($(e.target).val());
  // });

  // // 商品購入予約の数量の入力のやつの有効化・無効化
  // const $orderCheckers = $('.js_orderChecker');
  // $orderCheckers.each((index, element) => {
  // 	const $orderChecker = $(element);
  // 	const $orderCheckerTargert = $orderChecker.find('.js_orderChecker_target');
  // 	if ($orderChecker.find('input[type="checkbox"]').prop('checked')) {
  // 		$orderChecker.removeClass('is_disabled');
  // 		$orderCheckerTargert.find('select, option, input, textarea').prop('disabled', false);
  // 	} else {
  // 		$orderChecker.addClass('is_disabled');
  // 		$orderCheckerTargert.find('select, option, input, textarea').prop('disabled', true);
  // 	}

  // 	$orderChecker.on('change', 'input[type="checkbox"]', (e) => {
  // 		if ($orderChecker.find('input[type="checkbox"]').prop('checked')) {
  // 			$orderChecker.removeClass('is_disabled');
  // 			$orderCheckerTargert.find('select, option, input, textarea').prop('disabled', false);
  // 		} else {
  // 			$orderChecker.addClass('is_disabled');
  // 			$orderCheckerTargert.find('select, option, input, textarea').prop('disabled', true);
  // 		}
  // 	});
  // });
});

document.addEventListener("DOMContentLoaded", () => {
  const formGroups = document.querySelectorAll("[data-enablestatus='disable']");
  const selectors = document.querySelectorAll(
    "[data-control='dynamic-select'], input[type='radio'][data-selector]"
  );

  // 選択状態に応じてフォームの表示・非表示を更新する関数
  const updateFormVisibility = (selectedValues) => {
    formGroups.forEach((group) => {
      const targetValues = group.dataset.target.split(",");
      const inputs = group.querySelectorAll("input, select, textarea");

      const shouldShow = selectedValues.some((value) =>
        targetValues.includes(value)
      );

      group.style.display = shouldShow ? "block" : "none";
      inputs.forEach((input) => (input.disabled = !shouldShow));
    });

    // バリデーションのリセットと再適用
    ACMS.Dispatch._validate.validators = [];
    ACMS.Dispatch._validate.validators.checked = [];
    ACMS.Dispatch.validator(document);
  };

  // 選択された値を取得する関数
  const getSelectedValues = () =>
    [
      ...document.querySelectorAll(
        "select[data-control='dynamic-select'] option:checked"
      ),
      ...document.querySelectorAll(
        "input[type='radio'][data-selector]:checked"
      ),
    ].map((el) => el.dataset.selector);

  // 選択状態が変更されたときの処理
  const handleSelectionChange = () => updateFormVisibility(getSelectedValues());

  // イベントリスナーを設定
  selectors.forEach((selector) => {
    selector.addEventListener("change", handleSelectionChange);
  });

  // 初期状態をチェック（ページロード時の状態を反映）
  handleSelectionChange();
});

//------------------------エラー箇所へのスクロール

document.addEventListener("DOMContentLoaded", () => {
  const confirmButton = document.querySelector(
    'button[name="ACMS_POST_Form_Confirm"]'
  );

  confirmButton?.addEventListener("click", () => {
    setTimeout(scrollToFirstValidator, 100); // バリデーション適用後にスクロール
  });
});

const scrollToFirstValidator = () => {
  const validatorElement = document.querySelector(".validator-result-0");
  validatorElement
    ?.closest(".bl_formGroup")
    ?.scrollIntoView({ behavior: "smooth", block: "center" });
};
